import React from "react";
import UploadEye from "../../../../components/Nav & Header/Eye";
import ReactTooltip from "react-tooltip";
import FormTags from "../FormTags";
import Tags from "../../../../components/data/Tags.json";

import { AiTwotoneLock } from "@react-icons/all-files/ai/AiTwotoneLock";
import { AiOutlinePlus } from "@react-icons/all-files/ai/AiOutlinePlus";
import { MdKeyboardArrowLeft } from "@react-icons/all-files/md/MdKeyboardArrowLeft";

import Compress from "react-image-file-resizer";

import Chapter from "./NovelChaps/Chapter";
import AddChapter from "./NovelChaps/AddChapter";

function Update({
  getNovelId,
  setSlicingEmptyObjects,
  setUpdatedChaps,
  setRejectPushing,
  updatedChaps,
  deletedChapsId,
  setUpdatedChapsId,
  setDeletedChapsId,
  setNotChapter,
  notChapter,
  setIndexOfChap,
  setAddChap,
  chapterPopup,
  setChapterPopup,
  novelChapsU,
  setNovelChapsU,
  limitpopup,
  handleCheck,
  updatePopup,
  handleSubmitUpdate,
  novelDataU,
  setNovelDataU,
  setTagsScroll,
  tagsScroll,
  checked,
  setUpdatePopUp,
  error,
  sent,
}) {
  const onFileResize = (e) => {
    const file = e.target.files[0];

    Compress.imageFileResizer(
      file, // the file from input
      480, // width
      480, // height
      "WEBP", // compress format WEBP, JPEG, PNG
      80, // quality
      0, // rotation
      (uri) => {
        console.log("uri", uri);
        setNovelDataU({
          ...novelDataU,
          selectedFile: uri,
        }); // You upload logic goes here
      },
      "base64" // blob or base64 default base64
    );
  };

  return (
    <div>
      <div
        className={
          updatePopup
            ? "-translate-y-[0%] opacity-100 w-full md:w-full lg:w-full xl:w-[80%]  2xl:w-[70%] h-full md:h-[90%]  m-auto duration-500 ease-in-out fixed inset-0 z-[10000] "
            : "translate-y-[200%] opacity-0 w-full md:w-full lg:w-full xl:w-[80%]  2xl:w-[70%] h-full md:h-[90%]  m-auto duration-500 ease-in-out fixed inset-0 z-[10000] "
        }
      >
        <div className="w-full md:w-full lg:w-full xl:w-full  2xl:w-full h-full md:h-full">
          <div className="py-[100px] px-[15px] md:px-10  relative md:static overflow-y-scroll z-[1000] w-full md:w-full lg:w-full xl:w-full 2xl:w-full h-full md:h-full bg-tertiary duration-500 ease-in-out">
            <div className=" max-w-[1100px] m-auto">
              <form
                onSubmit={handleSubmitUpdate}
                className=" m-auto w-full flex flex-col gap-y-0 md:gap-y-6"
              >
                {/* first sec of form */}
                <div className="flex flex-col-reverse sm:flex-row w-full  gap-x-0 sm:gap-x-6  gap-y-8 sm:gap-y-8">
                  <div className="w-full sm:w-[55%] md:w-[60%] lg:w-[70%] flex flex-col gap-y-4 sm:gap-y-6">
                    <div className="relative w-full h-[52px]">
                      <input
                        className="px-4 md:px-8 text-[14px] sm:text-[16px] placeholder:text-secondary text-secondary/50 bg-primarys w-full h-[52px] outline-none"
                        placeholder="Title..."
                        disabled={true}
                        type="text"
                        value={novelDataU.title}
                        maxLength={30}
                        // onChange={(e) =>
                        //   setNovelDataU({
                        //     ...novelDataU,
                        //     title: e.target.value,
                        //   })
                        // }
                      />
                      {/* locked */}
                      <div
                        title="Blocked"
                        className="z-10 absolute top-1/2 -translate-y-1/2 left-1/2 -translate-x-1/2"
                      >
                        <AiTwotoneLock className="text-primarys text-[25px]" />
                      </div>
                      <div className="pr-[20%] pt-[100%] h-full -rotate-45 bg-tertiary absolute top-1/2 -translate-y-1/2 left-1/2 -translate-x-1/2 " />
                      <Tooltip1 />
                    </div>
                    <div className="relative w-full h-[400px] sm:h-full">
                      <textarea
                        maxLength={800}
                        placeholder="Description.."
                        className="py-4 md:py-6 text-[14px] sm:text-[16px] placeholder:text-secondary bg-primarys px-4 md:px-8 resize-none w-full h-full outline-none"
                        value={novelDataU.description}
                        onChange={(e) =>
                          setNovelDataU({
                            ...novelDataU,
                            description: e.target.value,
                          })
                        }
                      ></textarea>
                      <div
                        className={
                          novelDataU.description?.trim()?.split(/ +/)?.join(" ")
                            ?.length > 500
                            ? "text-primary text-[14px] sm:text-[16px] absolute bottom-0 right-0 py-4 md:py-6 px-4 md:px-8"
                            : "text-secondary text-[14px] sm:text-[16px] absolute bottom-0 right-0 py-4 md:py-6 px-4 md:px-8"
                        }
                      >
                        {
                          novelDataU.description?.trim()?.split(/ +/)?.join(" ")
                            ?.length
                        }
                        /800
                      </div>
                      <Tooltip2 />
                    </div>
                  </div>
                  <div className="relative w-full sm:w-[45%] md:w-[40%] lg:w-[30%] flex flex-col gap-y-4 sm:gap-y-6">
                    {novelDataU.selectedFile ? (
                      <img
                        className="createrectangle  w-full h-full object-cover"
                        src={novelDataU.selectedFile}
                        alt={novelDataU.title}
                      />
                    ) : (
                      <div className="bg-primarys createrectangle cursor-pointer  flex justify-center items-center  w-full h-full ">
                        <div className="scale-125 opacity-20 flex justify-center items-center">
                          <UploadEye />
                        </div>
                      </div>
                    )}
                    <Tooltip3 />
                    <label className="Purple-btn-effect flex justify-center items-center cursor-pointer font-SoraR hover:bg-primary/90 w-full h-[52px] bg-primary relative text-tertiary duration-300 ease-in-out">
                      <div className="hidden">
                        <input
                          type="file"
                          id="file"
                          accept="image/*"
                          onChange={onFileResize}
                        />
                      </div>
                      Upload
                    </label>
                  </div>
                </div>
                {/* second sec of form */}
                <div className="sm:mt-6 md:mt-0 mt-4">
                  <div className="relative w-full h-[52px]">
                    <input
                      className="bg-primarys text-[14px] sm:text-[16px] placeholder:text-secondary px-4 md:px-8 w-full h-full outline-none"
                      placeholder="Genre.."
                      type="text"
                      disabled={true}
                      // to give space to my input defaultValues
                      defaultValue={novelDataU.tags
                        .toString()
                        .replace(/,/g, ", ")}
                    />
                    <div className="z-50 relative mx-4 md:mx-8">
                      <div className=" h-[1px] w-full bg-primary"></div>
                    </div>
                    <Tooltip4 />
                  </div>
                  <div className="relative">
                    <div
                      onClick={() => setTagsScroll((prev) => !prev)}
                      className=" cursor-pointer w-[20px] h-[20px] bg-primary flex justify-center items-center absolute bottom-0 translate-y-1/2 left-1/2 -translate-x-1/2 z-[100]"
                    >
                      <MdKeyboardArrowLeft
                        className={
                          tagsScroll
                            ? "text-tertiary -rotate-90 duration-500 ease-in-out scale-75"
                            : "text-tertiary rotate-90 duration-500 ease-in-out scale-75"
                        }
                      />
                    </div>
                    <div
                      className={
                        tagsScroll
                          ? "relative flex flex-wrap gap-4 justify-center bg-primarys w-full p-[15px] py-8  md:p-10 max-h-[180px] overflow-hidden duration-500 ease-in-out"
                          : "relative flex flex-wrap gap-4 justify-center bg-primarys w-full p-[15px] py-8  md:p-10 max-h-[3000px] md:max-h-[2000px] lg:max-h-[900px] overflow-hidden h-full duration-500 ease-in-out"
                      }
                    >
                      <div className="flex flex-wrap gap-4 justify-center bg-primarys w-full h-full overflow-hidden">
                        {Tags.map((tag) => {
                          return (
                            <div key={tag.id}>
                              <FormTags
                                checked={checked}
                                onChange={handleCheck}
                                tag={tag.tagName}
                              />
                            </div>
                          );
                        })}
                      </div>
                      {/* popUps */}
                      <div>
                        {/* popUps */}
                        <div
                          className={
                            limitpopup
                              ? "bg-primary   duration-500 md:px-32 px-8 md:py-10 py-4 ease-in-out flex justify-center items-center  fixed inset-0 md:top-0 top-full -translate-y-1/2 md:-translate-y-20 z-[1000] opacity-100  w-full md:w-fit h-fit m-auto text-tertiary"
                              : "bg-primary   duration-500 md:px-32 px-8 md:py-10 py-4 ease-in-out flex justify-center items-center  fixed inset-0  md:top-0 top-full -translate-y-1/3 md:-translate-y-1/2 z-[1000] opacity-0 pointer-events-none invisible w-full md:w-fit  h-fit m-auto text-tertiary"
                          }
                        >
                          <h2 className="uppercase text-tertiary  w-fit h-fit justify-center items-center text-[16px] md:text-[20px] font-SoraR block">
                            3 tags are the limits
                          </h2>
                        </div>
                        <div
                          className={
                            chapterPopup
                              ? "bg-primary duration-500 md:px-32 px-8 md:py-10 py-4 ease-in-out flex justify-center items-center fixed inset-0  md:top-0 top-full -translate-y-1/2 md:-translate-y-20 z-[1000] opacity-100  w-full md:w-fit h-fit m-auto text-tertiary"
                              : "bg-primary duration-500 md:px-32 px-8 md:py-10 py-4 ease-in-out flex justify-center items-center  fixed inset-0 md:top-0 top-full -translate-y-1/3 md:-translate-y-1/2 z-[1000] opacity-0 pointer-events-none invisible  w-full md:w-fit h-fit m-auto text-tertiary"
                          }
                        >
                          <h2 className="uppercase text-center text-[14px] sm:text-[16px] md:text-[20px] text-tertiary  w-fit h-fit justify-center items-center font-SoraR block">
                            please fill In previous fields to continue
                          </h2>
                        </div>
                        <div
                          className={
                            notChapter === 0
                              ? "bg-error duration-500 md:px-32 px-8 md:py-10 py-4 ease-in-out flex justify-center items-center fixed inset-0  md:top-0 top-full -translate-y-1/2 md:-translate-y-20 z-[1000] opacity-100  w-full md:w-fit h-fit m-auto text-tertiary"
                              : "bg-error duration-500 md:px-32 px-8 md:py-10 py-4 ease-in-out flex justify-center items-center  fixed inset-0 md:top-0 top-full -translate-y-1/3 md:-translate-y-1/2 z-[1000] opacity-0 pointer-events-none invisible  w-full md:w-fit h-fit m-auto text-tertiary"
                          }
                        >
                          <h2 className="uppercase text-center text-tertiary  w-fit h-fit justify-center items-center text-[14px] sm:text-[16px] md:text-[20px] font-SoraR block">
                            deleted Successfully
                          </h2>
                        </div>
                        <div
                          className={
                            notChapter === 1
                              ? "bg-primary duration-500 md:px-32 px-8 md:py-10 py-4 ease-in-out flex justify-center items-center fixed inset-0  md:top-0 top-full -translate-y-1/2 md:-translate-y-20 z-[1000] opacity-100  w-full md:w-fit h-fit m-auto text-tertiary"
                              : "bg-primary duration-500 md:px-32 px-8 md:py-10 py-4 ease-in-out flex justify-center items-center  fixed inset-0 md:top-0 top-full -translate-y-1/3 md:-translate-y-1/2 z-[1000] opacity-0 pointer-events-none invisible  w-full md:w-fit h-fit m-auto text-tertiary"
                          }
                        >
                          <h2 className="uppercase text-center text-tertiary  w-fit h-fit justify-center items-center text-[14px] sm:text-[16px] md:text-[20px] font-SoraR block">
                            added Successfully
                          </h2>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* third sec of form */}
                <div className="pr-0 md:pr-2 w-full max-h-[250px] overflow-y-scroll flex flex-col  md:my-0 my-8  gap-y-2 md:gap-y-2">
                  {novelChapsU
                    ?.sort(
                      (a, b) => new Date(a.createdAt) - new Date(b.createdAt)
                    )
                    .map((chaps, index) => {
                      return (
                        <div key={index}>
                          <Chapter
                            setSlicingEmptyObjects={setSlicingEmptyObjects}
                            setRejectPushing={setRejectPushing}
                            setUpdatedChaps={setUpdatedChaps}
                            updatedChaps={updatedChaps}
                            deletedChapsId={deletedChapsId}
                            setDeletedChapsId={setDeletedChapsId}
                            id={chaps._id}
                            novelChapsU={novelChapsU}
                            setNovelChapsU={setNovelChapsU}
                            notChapter={notChapter}
                            setNotChapter={setNotChapter}
                            setIndexOfChap={setIndexOfChap}
                            setChapterPopup={setChapterPopup}
                            novelDataU={novelDataU}
                            setAddChap={setAddChap}
                            index={index}
                          />
                        </div>
                      );
                    })}
                  <AddChapter
                    getNovelId={getNovelId}
                    setSlicingEmptyObjects={setSlicingEmptyObjects}
                    setRejectPushing={setRejectPushing}
                    setIndexOfChap={setIndexOfChap}
                    setAddChap={setAddChap}
                    setChapterPopup={setChapterPopup}
                    novelDataU={novelDataU}
                    novelChapsU={novelChapsU}
                  />
                </div>
                {/* button */}
                <button
                  type="submit"
                  disabled={sent === true}
                  className="z-10 Purple-btn-effect font-SoraR hover:bg-primary/90 w-full h-[52px] bg-primary relative text-tertiary duration-300 ease-in-out"
                >
                  {sent ? <Loading /> : "Update Novel"}
                </button>
              </form>
              {/* errors */}
              <div
                className={
                  error
                    ? "bg-error text-[14px] sm:text-[16px] capitalize opacity-100 duration-500 ease-in-out translate-y-0  w-full h-[52px] flex items-center px-4 md:px-8 text-tertiary md:mt-6 mt-8"
                    : "bg-error text-[14px] sm:text-[16px] opacity-0 -translate-y-10 duration-500 ease-in-out capitalize  w-full h-0 flex items-center px-4 md:px-8 text-tertiary  mt-0"
                }
              >
                <h5>{error}</h5>
              </div>
            </div>
            {/* remove button */}
            <div
              onClick={() => {
                setUpdatePopUp(false);
                setUpdatedChapsId([]);
                setDeletedChapsId([]);
              }}
              className=" cursor-pointer absolute bg-error hover:bg-error/90 duration-500 ease-out w-[50px] md:w-[70px] h-[50px] md:h-[70px] top-0 right-0 translate-y-[40%] -translate-x-[15px] md:-translate-y-1/2 md:-translate-x-[40%] flex justify-center items-center"
            >
              <AiOutlinePlus className="flex justify-center items-center text-tertiary scale-[1.5] md:scale-[2] rotate-45" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Update;

function Tooltip1() {
  return (
    <>
      <div
        className="cursor-pointer absolute top-0 -translate-y-1/2 left-0 -translate-x-1/2"
        data-tip
        data-for="global1"
      >
        <div>
          <span className="  text-tertiary w-[16px] h-[16px] bg-primary flex justify-center items-center">
            <span className="scale-75">?</span>
          </span>
        </div>
      </div>
      <ReactTooltip
        id="global1"
        aria-haspopup="true"
        className="custom-color-no-arrow"
        delayHide={500}
        textColor="#D9D9D9"
        backgroundColor="#6947EF"
        effect="solid"
      >
        <div className="max-w-[220px] p-4 text-[13px] sm:text-[14px]">
          <h3 className="font-SoraR text-[15px] sm:text-[16px]">Novel Title</h3>
          <p className=" font-SoraL pt-2">
            I suggest you to make a simple title, which can easily explain the
            plot and attract audiences who are interested in this genre. For
            example, “The Postman Always Rings Twice” is better than “The
            Postman.
          </p>
        </div>
      </ReactTooltip>
    </>
  );
}
function Tooltip2() {
  return (
    <>
      <div
        className=" cursor-pointer absolute top-0 -translate-y-1/2 left-0 -translate-x-1/2"
        data-tip
        data-for="global2"
        href="="
      >
        <div>
          <span className="  text-tertiary w-[16px] h-[16px] bg-primary flex justify-center items-center">
            <span className="scale-75">?</span>
          </span>
        </div>
      </div>
      <ReactTooltip
        id="global2"
        aria-haspopup="true"
        className="custom-color-no-arrow"
        delayHide={500}
        textColor="#D9D9D9"
        backgroundColor="#6947EF"
        effect="solid"
      >
        <div className="max-w-[220px] p-4 text-[13px] sm:text-[14px]">
          <h3 className=" font-SoraR text-[15px] sm:text-[16px]">
            Novel Synopsis
          </h3>
          <p className=" font-SoraL pt-2">
            Explain the plot briefly but in detail and leave it at a cliffhanger
            (no major spoilers).
          </p>
        </div>
      </ReactTooltip>
    </>
  );
}
function Tooltip3() {
  return (
    <>
      <div
        className="cursor-pointer absolute top-0 -translate-y-1/2 left-0 -translate-x-1/2"
        data-tip
        data-for="global3"
        href="="
      >
        <div>
          <span className="text-tertiary w-[16px] h-[16px] bg-primary flex justify-center items-center">
            <span className="scale-75">?</span>
          </span>
        </div>
      </div>
      <ReactTooltip
        id="global3"
        aria-haspopup="true"
        className="custom-color-no-arrow"
        delayHide={500}
        textColor="#D9D9D9"
        backgroundColor="#6947EF"
        effect="solid"
      >
        <div className="max-w-[220px] p-4 text-[13px] sm:text-[14px]">
          <h3 className=" font-SoraR text-[15px] sm:text-[16px]">
            Novel Image
          </h3>
          <p className=" font-SoraL pt-2">
            i suggest you to make a an eye catching Image, which can easily
            explain the plot and attract audiences who are interested in this
            genre.
          </p>
        </div>
      </ReactTooltip>
    </>
  );
}
function Tooltip4() {
  return (
    <>
      <div
        className=" cursor-pointer absolute top-0 -translate-y-1/2 left-0 -translate-x-1/2"
        data-tip
        data-for="global4"
        href="="
      >
        <div>
          <span className="  text-tertiary w-[16px] h-[16px] bg-primary flex justify-center items-center">
            <span className="scale-75">?</span>
          </span>
        </div>
      </div>
      <ReactTooltip
        id="global4"
        aria-haspopup="true"
        className="custom-color-no-arrow"
        delayHide={500}
        textColor="#D9D9D9"
        backgroundColor="#6947EF"
        effect="solid"
      >
        <div className="max-w-[220px] p-4 text-[13px] sm:text-[14px]">
          <h3 className=" font-SoraR text-[15px] sm:text-[16px]">Novel Tags</h3>
          <p className=" font-SoraL pt-2">
            By using tags, it can reach a larger audience during the search
            process! I might find a "hidden gem".
          </p>
        </div>
      </ReactTooltip>
    </>
  );
}
function Loading() {
  return (
    <div className="flex justify-center items-center scale-75">
      <div role="status">
        <svg
          aria-hidden="true"
          className="mr-2 w-8 h-8 text-tertiary animate-spin fill-primary"
          viewBox="0 0 100 101"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
            fill="currentColor"
          ></path>
          <path
            d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
            fill="currentFill"
          ></path>
        </svg>
      </div>
      <span className="pl-4">Loading...</span>
    </div>
  );
}
